import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState, formatMessage } from 'src/api';
import { ApronBackSplashModel, ConfigurationModel } from 'franke-trough-dependencies';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Tooltip, Button } from 'reactstrap';
import { requestAPIActions } from 'loopback-react-request';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ApronBacksplash.messages';
import { hasSpaceForApron, requiredWidthForApron, requiredDistancesForApron, simulatedAprons, apronSpaceAvailable } from './Apron';

export interface ApronRequiredProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
  id: string;
  requiredHeight?: number;
  plateBuilder: GlobalPrivateState['plateBuilder'];
}

export interface ApronRequiredState {
  tooltipOpen: boolean;
}

export class ApronRequiredPartial extends React.Component<ApronRequiredProps, ApronRequiredState> {
  constructor(props: ApronRequiredProps) {
    super(props);

    this.state = {
      tooltipOpen: false
    };
    this.toggle = this.toggle.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  public render() {
    const id = this.props.id;
    const tollTipId = `apron_required_tooltip_${this.props.id}`;

    let requiredMessage = MESSAGES.apronHeightRequiredMessage;
    
    if (this.props.plateBuilder) {
      const aprons = simulatedAprons(this.props.plateBuilder);
      const spaces = apronSpaceAvailable(this.props.plateBuilder);

      if (!hasSpaceForApron(aprons, spaces)) {
        if (id === 'tissue_dispenser') {
          requiredMessage = MESSAGES.apronHeightAndDimensionsForTissueDispenserRequiredMessage;
        } else if (id === 'towel_rail') {
          requiredMessage = MESSAGES.apronHeightAndDimensionsForTowelRailRequiredMessage;
        } else if (id === 'cut_out_disposal') {
          requiredMessage = MESSAGES.apronHeightAndDimensionsForCutOutDisposalRequiredMessage;
        }
      } else {
        if (id === 'tissue_dispenser') {
          requiredMessage = MESSAGES.apronHeightForTissueDispenserRequiredMessage;
        } else if (id === 'towel_rail') {
          requiredMessage = MESSAGES.apronHeightForTowelRailRequiredMessage;
        } else if (id === 'cut_out_disposal') {
          requiredMessage = MESSAGES.apronHeightForCutOutDisposalRequiredMessage;
        }
      }
    }


    return this.apronRequired ? (
      <>
        <span className="info-icon" id={tollTipId}>
          <FontAwesomeIcon icon={faInfo} />
          <Tooltip 
            autohide={false}
            isOpen={this.state.tooltipOpen} 
            placement="top"
            toggle={this.toggle}
            target={tollTipId}
          >
            <p>
              <strong>
                <FormattedMessage {...MESSAGES.apronHeightRequiredHint}/>&nbsp;
              </strong> 
              <FormattedMessage {...requiredMessage} values={{requiredHeight: this.requiredHeight}}/>
            </p>
            <p className="text-right">
              <Button 
                onClick={(ev: React.MouseEvent<HTMLButtonElement>) => this.handleClick(ev, 'submit')}
                className="yes"
              >
                <FontAwesomeIcon icon={faCheck} />
              </Button>
            </p>
          </Tooltip>
        </span>
      </>
    ) : null;
  }

  private get apron(): ApronBackSplashModel['apron'] | null | undefined {
    return this.configuration &&
      this.configuration.apronBackSplash &&
      this.configuration.apronBackSplash.apron;
  }

  private get apronHeight(): ApronBackSplashModel['apronHeight'] | null | undefined {
    return this.configuration &&
      this.configuration.apronBackSplash &&
      this.configuration.apronBackSplash.apronHeight;
  }

  private get apronRequired(): boolean {
    return this.apron === 'without' ||
      (this.apron === 'with' && !this.apronHeight) || 
      (this.apron === 'with' && (this.apronHeight && this.apronHeight !== this.requiredHeight)) ? true : false;
  }

  private get configuration(): ConfigurationModel | undefined {
    return this.props.configuration && this.props.configuration.result;
  }

  private get requiredHeight(): number {
    return this.props.requiredHeight || 150;
  }

  private dispatchConfiguration() {
    if (!this.configuration) { return; }
    const { apronBackSplash, washBasinDimension } = this.configuration;

    // TODO ... Use default values for apronHeight
    if (!apronBackSplash || !this.props.plateBuilder) { return; }
    apronBackSplash.apron = 'with';
    apronBackSplash.apronHeight = this.requiredHeight;

    const aprons = simulatedAprons(this.props.plateBuilder);
    const spaces = apronSpaceAvailable(this.props.plateBuilder);

    if (!hasSpaceForApron(aprons, spaces)) {
      if (!washBasinDimension || !washBasinDimension.distances) { return; }
      
      apronBackSplash.restorablePlateDimensions = {
        plateWidth: washBasinDimension.plateWidth,
        distances: JSON.parse(JSON.stringify(washBasinDimension.distances))
      };

      washBasinDimension.plateWidth = requiredWidthForApron(aprons, spaces, washBasinDimension.plateWidth);
      washBasinDimension.distances = requiredDistancesForApron(aprons, spaces, washBasinDimension.distances)
    }

    this.props.dispatch(requestAPIActions.load(
      'configuration', {
        url: `/Configurations/${this.configuration && this.configuration.id}`,
        options: {
          method: 'PATCH',
          data: {
            apronBackSplash,
            washBasinDimension
          }
        },
      },
      true,
    ));
  }

  private handleClick(event: React.MouseEvent<HTMLButtonElement>, type: 'submit' | 'cancel') {
    if (type === 'submit') {
      this.dispatchConfiguration();
    }
  }

  private toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }
}

export const ApronRequired = connect((state: GlobalPrivateState) => ({
  plateBuilder: state.plateBuilder,
  configuration: state.configuration,
}))(ApronRequiredPartial);

export default ApronRequired;


